import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.modal.help.title',
        defaultMessage: 'Need help?'
    },
    phoneCaption: {
        id: '_.modal.help.phone_caption',
        defaultMessage: 'Call us on'
    },
    displayPhoneNumber: {
        id: '_.modal.help.display_number',
        defaultMessage: '020 3778 0105'
    },
    callPhoneNumber: {
        id: '_.modal.help.call_number',
        defaultMessage: '+44-020-3778-0105'
    },
    availabilityMessageLineOne: {
        id: '_.modal.help.availability_message_line_one',
        defaultMessage: 'Monday to Friday'
    },
    availabilityMessageLineTwo: {
        id: '_.modal.help.availability_message_line_two',
        defaultMessage: '9am - 6pm'
    },
    emailCaption: {
        id: '_.modal.help.email_caption',
        defaultMessage: 'Email us at'
    },
    email: {
        id: '_.modal.help.email',
        defaultMessage: 'support@iwoca.co.uk'
    },
    chatCaption: {
        id: '_.modal.help.chat_caption',
        defaultMessage: 'You can also'
    },
    chat: {
        id: '_.modal.help.chat',
        defaultMessage: 'chat to us!'
    },
    faqCaption: {
        id: '_.modal.help.faq_caption',
        defaultMessage: 'Find answers to common questions in our'
    },
    faq: {
        id: '_.modal.help.faq',
        defaultMessage: 'FAQs'
    }
});
